import { watch } from 'vue';

type SupportedLocale = 'en' | 'ar';

const STORAGE_KEY = 'app_locale';
const COOKIE_KEY = 'i18n_redirected';

function normalizeLocale(value: unknown): SupportedLocale | null {
  return value === 'ar' || value === 'en' ? value : null;
}

function getCookieLocale() {
  const match = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${COOKIE_KEY}=`));

  return normalizeLocale(match ? decodeURIComponent(match.split('=')[1]) : null);
}

function persistLocale(locale: SupportedLocale) {
  localStorage.setItem(STORAGE_KEY, locale);
  document.cookie = `${COOKIE_KEY}=${encodeURIComponent(locale)}; path=/; max-age=31536000`;
}

export default defineNuxtPlugin((nuxtApp) => {
  const i18n = (nuxtApp as any).$i18n;
  const localeRef = i18n?.locale;

  if (!localeRef || typeof localeRef !== 'object' || !('value' in localeRef)) {
    return;
  }

  const persistedLocale =
    normalizeLocale(localStorage.getItem(STORAGE_KEY)) ?? getCookieLocale();

  if (persistedLocale && normalizeLocale(localeRef.value) !== persistedLocale) {
    localeRef.value = persistedLocale;
  }

  const initialLocale = normalizeLocale(localeRef.value);
  if (initialLocale) {
    persistLocale(initialLocale);
  }

  watch(localeRef, (next) => {
    const normalized = normalizeLocale(next);
    if (normalized) {
      persistLocale(normalized);
    }
  });
});
